import { render, staticRenderFns } from "./ed-dropdown.vue?vue&type=template&id=2993abd0&scoped=true"
import script from "./ed-dropdown.vue?vue&type=script&lang=js"
export * from "./ed-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2993abd0",
  null
  
)

export default component.exports